// extracted by mini-css-extract-plugin
export default {"manageFormWrapper":"Detail_manageFormWrapper__qPomH","manageForm":"Detail_manageForm__Mq1ap","manageFormInput":"Detail_manageFormInput__hC1ix"};